module.exports = "/images/dk.svg?dd5cd070fbd7e47c4c6ba028ea3cb44c";